/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderParticipant } from './LadderParticipant';
import {
    LadderParticipantFromJSON,
    LadderParticipantFromJSONTyped,
    LadderParticipantToJSON,
    LadderParticipantToJSONTyped,
} from './LadderParticipant';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface GetLadderStandingsResponse
 */
export interface GetLadderStandingsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetLadderStandingsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<LadderParticipant>}
     * @memberof GetLadderStandingsResponse
     */
    standings: Array<LadderParticipant>;
}

/**
 * Check if a given object implements the GetLadderStandingsResponse interface.
 */
export function instanceOfGetLadderStandingsResponse(value: object): value is GetLadderStandingsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('standings' in value) || value['standings'] === undefined) return false;
    return true;
}

export function GetLadderStandingsResponseFromJSON(json: any): GetLadderStandingsResponse {
    return GetLadderStandingsResponseFromJSONTyped(json, false);
}

export function GetLadderStandingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLadderStandingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'standings': ((json['standings'] as Array<any>).map(LadderParticipantFromJSON)),
    };
}

export function GetLadderStandingsResponseToJSON(json: any): GetLadderStandingsResponse {
    return GetLadderStandingsResponseToJSONTyped(json, false);
}

export function GetLadderStandingsResponseToJSONTyped(value?: GetLadderStandingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'standings': ((value['standings'] as Array<any>).map(LadderParticipantToJSON)),
    };
}

